import { render, staticRenderFns } from "./RankPoint.vue?vue&type=template&id=28e0aa02&"
import script from "../../models/analysis/rank-point.ts?vue&type=script&lang=ts&"
export * from "../../models/analysis/rank-point.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports